import createElement from '../logical-components/createElement';
// Global helpers
import svgs from '../visual-components/svgs';
import renderText from '../logical-components/renderText';
import internalEvents from '../logical-components/internalEvents';
var generateMeta = function (config, section, data) {
    var _a;
    if (data === null || data === void 0 ? void 0 : data.meta) {
        var events = internalEvents(config);
        var DOM = createElement('div');
        var wrapper = createElement('div', [
            { type: 'class', value: '_mnslq-card-meta' },
        ]);
        if ((_a = section === null || section === void 0 ? void 0 : section.views) === null || _a === void 0 ? void 0 : _a.meta) {
            var ele = section.views.meta({
                config: config,
                section: section,
                data: data,
                svgs: svgs,
                renderText: renderText,
                events: events,
                wrapper: wrapper,
            });
            if (typeof ele === 'string') {
                wrapper.innerHTML = ele;
            }
            else {
                wrapper.appendChild(ele);
            }
        }
        else {
            // Cards sent
            wrapper.innerHTML += "<div class='mensenlinq-card-metaitem'>\n                ".concat(svgs.write, "\n                <span class='mens-card-meta-writes'>\n                    ").concat(data.meta.writes, "\n                </span>\n            </div>");
            // Flowers sent
            wrapper.innerHTML += "<div class='mensenlinq-card-metaitem'>\n                ".concat(svgs.flower, "\n                <span class='mens-card-meta-flowers'>\n                    ").concat(data.meta.flowers, "\n                </span>\n            </div>");
            // Candles sent
            wrapper.innerHTML += "<div class='mensenlinq-card-metaitem'>\n                ".concat(svgs.candle, "\n                <span class='mens-card-meta-candles'>\n                    ").concat(data.meta.candles, "\n                </span>\n            </div>");
        }
        // Pass the template back as a string
        DOM.appendChild(wrapper);
        return DOM.innerHTML;
    }
    return '';
};
export default generateMeta;
